import _ from 'lodash';
import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '@deegital/trustup-spa-js-assets/tailwind.js';

const fullConfig = resolveConfig(tailwindConfig);
    
export default class Screen {
    
    constructor() {
        this.setWidth();
    }

    setWidth()
    {
        this.width = window.innerWidth;
    }

    getCurrent()
    {
        let current = 'default';

        for (const [key, value] of Object.entries(this.getBreakpoints())) {
            if ( this.isLargerThan(value) ) {
                current = key;
            }
        }
        
        return current;
    }

    getBreakpoints()
    {
        return fullConfig.theme.screens;
    }

    getBreakpoint(key)
    {
        return this.getBreakpoints()[key];
    }

    isDefault()
    {
        return ! this.isLargerThanBreakpoint('sm');
    }

    isLargerThan(width)
    {
        return this.width >= parseInt(width);
    }

    isLargerThanBreakpoint(breakpoint)
    {
        return this.isLargerThan( this.getBreakpoint(breakpoint) );
    }

    isBreakpointOrLess(breakpoint)
    {
        switch (breakpoint) {
            case 'sm':
                return this.isSmOrLess();
            case 'md': 
                return this.isMdOrLess();
            case 'lg': 
                return this.isLgOrLess();
            default: 
                return false;    
        }
    }

    isSm()
    {
        return this.isLargerThanBreakpoint('sm');
    }

    isExactlySm()
    {
        return this.isLargerThanBreakpoint('sm') && ! this.isLargerThanBreakpoint('md');
    }

    isSmOrLess()
    {
        return ! this.isLargerThanBreakpoint('md');
    }

    isMd()
    {
        return this.isLargerThanBreakpoint('md');
    }

    isExactlyMd()
    {
        return this.isLargerThanBreakpoint('md') && ! this.isLargerThanBreakpoint('lg');
    }

    isMdOrLess()
    {
        return ! this.isLargerThanBreakpoint('lg');
    }

    isLg()
    {
        return this.isLargerThanBreakpoint('lg');
    }

    isExactlyLg()
    {
        return this.isLargerThanBreakpoint('lg') && ! this.isLargerThanBreakpoint('xl');
    }

    isLgOrLess()
    {
        return ! this.isLargerThanBreakpoint('xl');
    }

    isXl()
    {
        return this.isLargerThanBreakpoint('xl');
    }
}

window.addEventListener('resize', _.debounce(() => {
    window.App.$screen.setWidth();
}, 50));